/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber2Small = createReactComponent("number-2-small", "IconNumber2Small", [
  [
    "path",
    {
      d: "M10 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3",
      key: "svg-0"
    }
  ]
]);

export { IconNumber2Small as default };
//# sourceMappingURL=IconNumber2Small.js.map
